import { useGet } from "@/api/useApi";

export function useAgencyClientsSearch({
  companyId,
  agencyId,
  filterKey,
  page,
  pageSize,
  enabled,
  companyName,
}) {
  const params = {
    resource: "companies",
    filter_key: filterKey,
    page: String(page),
    page_size: String(pageSize),
  };

  if (companyName) {
    params.company_name = companyName;
  }

  const url =
    companyId && agencyId
      ? `companies/${companyId}/search/agencies/${agencyId}`
      : "companies/_/search/agencies/_";

  return useGet("agency-clients", url, params, {
    enabled:
      Boolean(enabled) &&
      Boolean(companyId) &&
      Boolean(agencyId),
  });
}
